import React from "react";
import BusinessList from "./businessList";
import Header from "../../components/default/header";
import { Helmet } from "react-helmet";
import GlobalSidebarMenu from "../default/header/globalSidebarMenu";
import Breadcrumb from "../default/breadcrumb/breadcrumb";

const Business = () => {
    return (
        <div className="business-wrapper sidebar-menu-enable">
            <Helmet title="Business - Cardiast" />
            <Header />
            <div className="sidebar-with-content ds-flex">
                <GlobalSidebarMenu sidebarTitle="Business"/>
                <div className="content-right">
                    <Breadcrumb />
                    <BusinessList />
                </div>
            </div>
        </div>
    );
}

export default Business;